// const defaultLogo = "https://api.jobian.com/storage/settings/February2020/Fuz6eo8V7vo3iFOJVqzh.png"

setLogoMeta()
setContactsMeta()
setSocMeta()

function setLogoMeta() {
  const tag = createTagScriptJSON()
  const content = {
    "@context": "http://schema.org/",
    "@type": "Organization",
    "name": "jobian",
    "url": "https://jobian.com/",
    "logo": globalConfigs.header.logo_horizontal
  }

  tag.innerHTML = JSON.stringify(content)
  document.head.appendChild(tag)
}

function setContactsMeta() {
  const tag = createTagScriptJSON()
  // const phones = []

  const content = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "jobian",
    "url": "https://jobian.com/",
    "logo": globalConfigs.header.logo_horizontal,
    "department": [{
      "@type": "Organization",
      "url": "https://jobian.com/",
      "logo": "https://api.jobian.com/storage/settings/February2020/Fuz6eo8V7vo3iFOJVqzh.png",
      "address": {
        "email": globalConfigs.jsonld_contacts.email,
        "streetAddress": globalConfigs.jsonld_contacts.location,
        "addressLocality": globalConfigs.jsonld_contacts.address
      },
      "telephone": globalConfigs.jsonld_contacts.phones
    }]
  }


  tag.innerHTML = JSON.stringify(content)
  document.head.appendChild(tag)
}

function setSocMeta() {
  const tag = createTagScriptJSON()
  const sameAs = globalConfigs.footer.channels.map(item => item.url)

  const content = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "jobian",
    "url": "https://jobian.com/",
    sameAs
  }

  tag.innerHTML = JSON.stringify(content)
  document.head.appendChild(tag)
}

function createTagScriptJSON() {
  const tag = document.createElement('script')
  tag.setAttribute('type', 'application/ld+json')

  return tag
}
